import { gql } from '@apollo/client';
const AUTOCOMPLETE_PRODUCT_CATEGORIES = gql `
  query GetAutocompleteProductCategories {
    autocomplete {
      id
      productCategories {
        edges {
          node {
            id
            type
            typeLabelPL
            typeLabelEN
            typeIcon
            displayOrder
            filtersAvailable
            hasName
            hasComposition
            hasComponentSize
            hasSupplier
            hasProductDescription
            hasWidth
            hasZipperType
            hasUpperSliderType
            hasUnderSliderType
            variantHasColor
            variantHasChainColor
            variantHasTapeColor
            variantHasSliderColor
            variantHasSize
            hasGrammage
            hasProducerCode
            hasYardage
            colorAutoCalculationMethod
            nameAutoCalculationMethod
            productsCount
          }
        }
      }
    }
  }
`;
export default AUTOCOMPLETE_PRODUCT_CATEGORIES;
